export default "__VITE_ASSET__0433f98b__"